import { render, staticRenderFns } from "./IconMoon.vue?vue&type=template&id=5d3d18ba&"
import script from "./IconMoon.vue?vue&type=script&setup=true&lang=js&"
export * from "./IconMoon.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports